import React from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import {gradientRgb} from "utilities/helperFunctions";
import ChipText from "connectui/component/display/chip/ChipText";
import OutlinedChipBase from "connectui/component/display/chip/base/OutlinedChipBase";
import FilterListChip from "../../filterlist/FilterListChip";
import Tooltip from "connectui/component/display/Tooltip";
import ChipRow from "../../../../../connectui/component/display/chip/ChipRow";

const BookingTags = ({bookingTags = []}) => {
  const {theme} = useTheme();

  const tags = bookingTags.filter(
    (tag) => !["Verified", "Revoked"].includes(tag),
  );
  const visibleTags = tags.slice(0, 2);
  const hiddenTags = tags.slice(2);

  const chipStyles = {
    color: theme.colors.white,
    border: "1px solid",
    borderColor: theme.colors.white,
    background: gradientRgb(theme.colors.black, 0.25),
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
    "&:hover": {
      background: gradientRgb(theme.colors.black, 0.3),
    },
  };

  const getChips = () => {
    const chips = [];
    visibleTags.forEach((tag) => {
      chips.push({
        Component: (props) => (
          <Tooltip
            interactive
            leaveDelay={150}
            tooltipContent={props.text}
            colors={{bg: "gray900", text: "white"}}
            sx={{
              trigger: {overflow: "hidden", flex: 1, maxWidth: "fit-content"},
              tooltip: {
                padding: theme.spacing(2),
                maxWidth: 350,
                maxHeight: 200,
                whiteSpace: "pre-wrap",
              },
            }}
          >
            <ChipText {...props} />
          </Tooltip>
        ),
        text: tag,
        color: theme.colors.white,
        chipBase: OutlinedChipBase,
        sx: {...chipStyles, flex: 1, width: "100%"},
        textProps: {
          sx: {
            textOverflow: "ellipsis",
            overflow: "hidden",
          },
        },
      });
    });
    if (hiddenTags.length > 0) {
      chips.push({
        Component: FilterListChip,
        value: `+${hiddenTags.length}`,
        textColor: theme.colors.white,
        chipBase: OutlinedChipBase,
        tooltip: {
          colors: {
            bg: "gray900",
            text: "white",
          },
          sx: {trigger: {minWidth: "fit-content"}},
          tooltipContent: (
            <ChipRow
              wrap
              sx={{
                maxWidth: 350,
                maxHeight: 200,
                overflow: "auto",
              }}
              chips={hiddenTags.map((t) => ({
                Component: ChipText,
                text: t,
                color: theme.colors.white,
                chipBase: OutlinedChipBase,
                sx: chipStyles,
                textProps: {
                  sx: {
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  },
                },
              }))}
            />
          ),
        },
        sx: chipStyles,
      });
    }
    return chips;
  };

  return (
    <ChipRow
      chips={getChips()}
      gap={theme.spacing(1)}
      sx={{overflow: "hidden"}}
    />
  );
};

export default BookingTags;
